import { useEffect, useState } from "react";
import { useRouteError } from "react-router";
import { Button } from "@myela/ui";
import { Loader } from "@/components/common/Loader";
import { canAutoReload, isChunkLoadError, markAutoReload } from "@/lib/chunkReload";

// Root errorElement. A missing route chunk means the portal was redeployed while this
// tab was open, so reload into the current build instead of showing an error.
export default function RouteError() {
  const error = useRouteError();
  const staleBuild = isChunkLoadError(error);
  const [autoReload] = useState(() => staleBuild && canAutoReload());

  useEffect(() => {
    if (!autoReload) return;
    markAutoReload();
    window.location.reload();
  }, [autoReload]);

  if (autoReload) {
    return (
      <div className="flex min-h-svh items-center justify-center">
        <Loader size={32} />
      </div>
    );
  }

  return (
    <div
      role="alert"
      className="flex min-h-svh flex-col items-center justify-center gap-4 px-4 text-center"
    >
      <h1 className="text-lg font-semibold">Something went wrong</h1>
      <p className="text-sm text-muted-foreground">
        {staleBuild
          ? "This page couldn't load the latest version of the portal."
          : "An unexpected error occurred."}{" "}
        Reload the page to try again.
      </p>
      <Button onClick={() => window.location.reload()}>Reload</Button>
    </div>
  );
}
